module.exports = __webpack_public_path__ + "static/media/31.72bfacb6.jpg";